export const breakpoints = {
  xxs: 0,
  xs: 360,
  sm: 564,
  md: 768,
  lg: 1088,
  xl: 1450,
};

export const containerMaxWidths = {
  sm: 528,
  md: 612,
  lg: 1056,
};

export const screen = {
  xxs: `(min-width: ${breakpoints.xxs}px)`,
  xs: `(min-width: ${breakpoints.xs}px)`,
  sm: `(min-width: ${breakpoints.sm}px)`,
  md: `(min-width: ${breakpoints.md}px)`,
  lg: `(min-width: ${breakpoints.lg}px)`,
  xl: `(min-width: ${breakpoints.xl}px)`,
};
